var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TypographyHeading, LocationIcon, InfoItem, Stacker, Styler, Expand } from '@honeycomb/ui-core';
import { getHotelLocation } from '../../utils';
import { HotelRatings } from '../../HotelRatings';
export function HotelHeadline(_a) {
    var { hotelDetails, compact = false, onReviewsDialogTriggerClick } = _a, other = __rest(_a, ["hotelDetails", "compact", "onReviewsDialogTriggerClick"]);
    const { name, geography } = hotelDetails;
    const hotelLocation = geography && getHotelLocation(geography);
    return (React.createElement(Styler, Object.assign({}, other),
        React.createElement(TypographyHeading, { component: "h1", size: compact ? 's' : 'm', transition: "font-size 200ms ease", "data-id": "hotel-name" }, name),
        React.createElement(Expand, { in: !compact, timeout: { enter: 300, exit: 300 } },
            React.createElement(Stacker, { spacing: 3, pt: 3 },
                React.createElement(InfoItem, { icon: React.createElement(LocationIcon, null), "data-id": "hotel-location" }, hotelLocation),
                React.createElement(HotelRatings, { hotel: hotelDetails, onDialogTriggerClick: onReviewsDialogTriggerClick })))));
}
